import React from 'react'
import RowButton from 'components/atoms/row-button'

/**
 * Featured Seller Landing Page Section Table Columns
 */
const CmsFeaturedSellerLandingPageFsTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick,
  isButtonDisabled
}) => {
  // Custom Cell
  // Used to modify the cell in specific columns

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => {

    // eslint-disable-next-line react/prop-types
    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <RowButton
        // eslint-disable-next-line react/prop-types
        data={ row.original }
        color={ buttonColour }
        onClick={ onButtonClick }
        text={ buttonText }
        disabled={ disabled }
      />
    )
  }

  return (
    [
      {
        Header  : 'Featured Sellers',
        columns : [
          {
            Header         : 'Name',
            accessor       : 'seller.name',
            disableFilters : true
          },
          {
            Header         : 'Username',
            accessor       : 'seller.username',
            disableFilters : true
          },
          {
            Header         : 'Email',
            accessor       : 'seller.email',
            disableFilters : true
          },
          {
            Header : 'Action',
            id     : 'action',
            Cell   : ActionCell
          }
        ]
      }
    ]
  )
}

export default CmsFeaturedSellerLandingPageFsTableColumns